// possible values for icon font-size.
export enum FontSize {
  ICON_SIZE_12 = '12',
  ICON_SIZE_13 = '13',
  ICON_SIZE_14 = '14',
  ICON_SIZE_15 = '15',
  ICON_SIZE_16 = '16',
  ICON_SIZE_17 = '17',
  ICON_SIZE_18 = '18',
  ICON_SIZE_19 = '19',
  ICON_SIZE_20 = '20',
  ICON_SIZE_21 = '21',
  ICON_SIZE_22 = '22',
  ICON_SIZE_23 = '23',
  ICON_SIZE_24 = '24',
}

export enum ButtonSize {
  SIZE_24 = '24',
  SIZE_32 = '32',
}

export enum ButtonType {
  ROUND = 'round',
  SQUARE = 'square',
  NO_HOVER = 'no_hover',
}

export enum ButtonFill {
  QUIET = 'quiet',
  SECONDARY = 'secondary',
  NEGATIVE = 'negative',
  PRIMARY = 'primary',
  SUCCESS = 'success',
  OUTLINE = 'outline',
}

//values for IconButton colors
export enum ButtonColor {
  PRIMARY = 'primary',
  PRIMARY_ACTIVE = 'primary-active',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  NEGATIVE = 'negative',
  WARNING = 'warning',
  WHITE = 'white',
}
